import React from 'react'
import actionWays from "../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { message, Modal, Form, Input, Button, Checkbox, Row, Col, Select, Card, DatePicker, InputNumber } from "antd";
import { getTransactionTodoList, getApplyEvictionDetail, applyEviction, editApplyEviction, getApplyEvictionDateList, getSaveApplyEviction, getTemplate } from '../utils/api'
import moment from "moment";
import UploadsDocx from '../components/common/Uploads/uploadsDocx'
import { CloudDownloadOutlined } from '@ant-design/icons';
class modalBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFlag: false,
            expireTime: '',
            picture: '',
            file: '',
            dateList: [],
            contractAttribute: ''
        }
    }
    componentDidMount() {
        console.log(this.props.drawbackIdList);
        console.log(this.props.contractList);
        console.log(this.props.showDrawback);
        console.log(this.props.userLoginInfo);
        if (this.props.contractList?.contractAttribute) {
            if (this.props.contractList.contractAttribute == '01' || this.props.contractList.contractAttribute == '03') {
                this.setState({
                    contractAttribute: '个人',
                })
            }
            if (this.props.contractList.contractAttribute == '02' || this.props.contractList.contractAttribute == '05') {
                this.setState({
                    contractAttribute: '单位',
                })
            }
        }
        if (this.props.drawbackIdList?.contractAttribute) {
            if (this.props.drawbackIdList.contractAttribute == '01' || this.props.drawbackIdList.contractAttribute == '03') {
                this.setState({
                    contractAttribute: '个人',
                })
            }
            if (this.props.drawbackIdList.contractAttribute == '02' || this.props.drawbackIdList.contractAttribute == '05') {
                this.setState({
                    contractAttribute: '单位',
                })
            }
        }
        if (this.props.contractList && (this.props.contractList.commitType != '暂存' || !this.props.contractList.commitType)) {
            this.setState({
                showFlag: true,
            })
        }
        if (this.props.contractList && this.props.contractList.commitType == '暂存' && !this.props.drawbackIdList) {
            this.getSaveApplyEviction(this.props.contractList.contractNo)
        }
        if (!this.props.contractList && this.props.drawbackIdList) {
            this.getApplyEvictionDetail(this.props.drawbackIdList.id)
        }
        // if (this.props.showDrawback) {
        //     this.sureAsurname('showDrawback')
        // } else if (this.props.userLoginInfo.idno) {
        //     this.sureAsurname('idno')
        // }
    }
    sureAsurname = async (type) => {
        if (type == 'idno') {
            let list = await getTransactionTodoList({ idno: this.props.userLoginInfo.idno })
            if (list.code == 0) {
                if (list.data?.todoList?.expireTime) {
                    this.setState({
                        showFlag: true,
                        expireTime: list.data?.todoList?.expireTime
                    }, () => {
                        this.getTransactionTodoList(list)
                    })
                }
                this.props.showMoveBox(list.data?.perfectStatus)
            } else {
                message.error(list.message)
            }
        } else if (type == 'showDrawback') {
            this.setState({
                showFlag: true,
            }, () => {
                this.getTransactionTodoList()
            })
        }
    }
    getApplyEvictionDateList = async (value) => {
        // console.log(moment(this.props.contractList.contractStartDate).format('YYYY-MM-DD'));
        // console.log(moment(this.props.contractList.contractEndDate).format('YYYY-MM-DD'));
        // console.log(value);
        // return
        let contractStartDate = ''
        let contractEndDate = ''
        if (this.props.contractList) {
            contractStartDate = moment(this.props.contractList.contractStartDate).format('YYYY-MM-DD')
            contractEndDate = moment(this.props.contractList.contractEndDate).format('YYYY-MM-DD')
        }
        if (this.props.drawbackIdList) {
            contractStartDate = moment(this.props.drawbackIdList.contractStartDate).format('YYYY-MM-DD')
            contractEndDate = moment(this.props.drawbackIdList.contractEndDate).format('YYYY-MM-DD')
        }
        let list = null
        list = await getApplyEvictionDateList({ evictionType: value, contractStartDate, contractEndDate })
        this.refs.showFlagRef.setFieldsValue({ applyEvictionDate: [] })
        if (list.code == 0) {
            this.setState({
                dateList: list.data
            })
        } else {
            this.setState({
                dateList: []
            })
            message.success(list.message)
        }
    }
    getSaveApplyEviction = async (contractNo) => {
        let list = null
        list = await getSaveApplyEviction({ contractNo: contractNo })
        if (list.code == 0) {
            const dataList = list.data
            this.getApplyEvictionDateList(list.data.evictionType)
            this.setState({
                picture: dataList.picture,
                file: dataList.file,
                showFlag: true,
            })
            // dataList.applyEvictionDate = moment(dataList.evictionDate)
            dataList.applyEvictionDate = dataList.evictionDate
            delete dataList.evictionDate
            console.log(dataList);
            // console.log(this.state.picture);
            // console.log(this.state.file);
            this.refs.showFlagRef.setFieldsValue(dataList)
        }
    }
    getTemplate = async (e, link) => {
        let opts = {}
        opts.name = '退房申请表'
        const list = await getTemplate(opts)
        if (list.code == 0) {
            let url = list.data ? list.data : null;
            if (url) {
                // window.open(url, '__blank')
                // const newWindow = window.open('', '_blank');
                // // 异步操作完成后
                // newWindow.location.href = url;
                const link = document.createElement('a');
                link.href = url;
                link.download = '退租申请表.docx'; // 设置下载文件名
                // link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            message.error(list?.message)
        }
    };
    getApplyEvictionDetail = async (id) => {
        let list = null
        list = await getApplyEvictionDetail({ id: id })
        if (list.code == 0) {
            const dataList = list.data
            this.getApplyEvictionDateList(list.data.evictionType)
            this.setState({
                picture: dataList.picture,
                file: dataList.file,
                showFlag: true,
            })
            // dataList.applyEvictionDate = moment(dataList.evictionDate)
            dataList.applyEvictionDate = dataList.evictionDate
            delete dataList.evictionDate
            delete dataList.evictionDate
            console.log(dataList);
            // console.log(this.state.picture);
            // console.log(this.state.file);
            this.refs.showFlagRef.setFieldsValue(dataList)
        }
    }
    getTransactionTodoList = async (lists) => {
        let list = null
        if (lists) {
            list = lists
        } else {
            list = await getTransactionDetailById({ id: this.props.ModalBoxId })
        }
        if (list.code == 0) {
            const dataList = list.data
            if (dataList.province) {
                if (!(dataList.province instanceof Array)) {
                    dataList.province = JSON.parse(dataList.province)
                }
            }
            dataList.province = dataList.province ? dataList.province instanceof Array ? dataList.province : [dataList.province, dataList.city, dataList.district] : undefined
            // 共同申请人
            for (let i in dataList.transactionPersonBeanList) {
                if (!dataList.transactionPersonBeanList[i]) {
                    dataList.transactionPersonBeanList = []
                    break
                }
                dataList.transactionPersonBeanList[i].id = i
            }
            if (dataList.registeredType.slice(0, 2) !== '上海' && dataList.registeredType !== '本市' && !dataList.holdLivingCardYear) {
                if (dataList.applyAttruble == '个人') {
                    dataList.holdLivingCardYear = '是'
                } else if (dataList.applyAttruble == '单位') {
                    dataList.holdLivingCardYear = '否'
                }
            }
            if (dataList.registeredType.slice(0, 2) == '上海' || dataList.registeredType == '本市') {
                this.setState({
                    dataList: dataList,
                    // registeredType: dataList.registeredType,
                    registeredType: '本市',
                    sqTypes: dataList.applyAttruble,
                })
            } else {
                this.setState({
                    dataList: dataList,
                    // registeredType: dataList.registeredType,
                    registeredType: '外省市',
                    sqTypes: dataList.applyAttruble,
                })
            }
            // console.log(dataList);
            this.refs.showFlagRef.setFieldsValue(dataList)
        } else {
            message.error(list.message)
        }
    }
    changeApplyAttruble = (v) => {
        this.setState({
            sqTypes: v,
        })
    }
    setCommonFile = (img, type, imgTmp) => {
        img = img.toString()
        let { file } = this.state
        file = img
        this.setState({
            file: file
        })
    }
    setCommonImages = (img, type, imgTmp) => {
        img = img.toString()
        let { picture } = this.state
        picture = img
        this.setState({
            picture: picture
        })
    }
    onFinishFailed = ({ values, errorFields, outOfDate }) => {
        console.log(this.state.picture);
        console.log(this.state.file);
        console.log(values);
        message.error('提交失败，您有信息未填写')
    }
    onFinish = async (values) => {
        if (this.state.picture.length < 1 && this.state.file.length < 1) {
            message.error('请上传图片或附件！')
            return
        }
        let opts = {}
        opts = values
        opts.applyEvictionDate = moment(opts.applyEvictionDate).format('YYYY-MM-DD')
        opts.picture = this.state.picture.toString()
        opts.file = this.state.file.toString()
        opts.operator = this.props.userLoginInfo.username
        opts.source = '官网'
        opts.commitType = '提交'
        if (this.props.contractList) {
            opts.contractNo = this.props.contractList.contractNo
            opts.houseId = this.props.contractList.houseId
            let list = await applyEviction(opts)
            // console.log(opts);
            // return
            if (list.code === 0) {
                message.success('操作成功')
                this.setState({
                    showFlag: false,
                    // expireTime: ''
                })
                window.location.reload();
            } else {
                message.error(list.message)
            }
        }
        if (!this.props.contractList && this.props.drawbackIdList) {
            opts.id = this.props.drawbackIdList.id
            opts.contractNo = this.props.drawbackIdList.contractNo
            opts.houseId = this.props.drawbackIdList.houseId
            // console.log(opts);
            // return
            let list = await editApplyEviction(opts)
            // console.log(opts);
            // return
            if (list.code === 0) {
                message.success('操作成功')
                this.setState({
                    showFlag: false,
                    // expireTime: ''
                })
                window.location.reload();
            } else {
                message.error(list.message)
            }
        }
    }
    temporaryStorage = async () => {
        let opts = {}
        opts = this.refs.showFlagRef.getFieldsValue()
        opts.applyEvictionDate = opts.applyEvictionDate ? moment(opts.applyEvictionDate).format('YYYY-MM-DD') : ''
        opts.picture = this.state.picture.toString()
        opts.file = this.state.file.toString()
        opts.operator = this.props.userLoginInfo.username
        opts.source = '官网'
        opts.commitType = '暂存'
        if (this.props.contractList) {
            opts.contractNo = this.props.contractList.contractNo
            opts.houseId = this.props.contractList.houseId
            let list = await applyEviction(opts)
            // console.log(opts);
            // return
            if (list.code === 0) {
                message.success('操作成功')
                this.setState({
                    showFlag: false,
                    // expireTime: ''
                })
                window.location.reload();
            } else {
                message.error(list.message)
            }
        }
        if (!this.props.contractList && this.props.drawbackIdList) {
            opts.id = this.props.drawbackIdList.id
            opts.contractNo = this.props.drawbackIdList.contractNo
            opts.houseId = this.props.drawbackIdList.houseId
            // console.log(opts);
            // return
            let list = await editApplyEviction(opts)
            // console.log(opts);
            // return
            if (list.code === 0) {
                message.success('操作成功')
                this.setState({
                    showFlag: false,
                    // expireTime: ''
                })
                window.location.reload();
            } else {
                message.error(list.message)
            }
        }
    }
    render() {
        const { showFlag, showInFlag, showCheckFlag, picture, file, dateList, contractAttribute } = this.state
        const { showDrawback, changeShowDrawback } = this.props
        return (
            <div>
                <Modal width={1200} visible={showFlag} closable={showDrawback ? showDrawback : false} maskClosable={showDrawback ? showDrawback : false} onCancel={() => { this.setState({ showFlag: false }); changeShowDrawback() }} footer={false}>
                    <div style={{ width: '100%', padding: '0 24px 20px 24px' }}>
                        <h4 style={{ fontWeight: 'bold' }}>申请退租</h4>
                        <p style={{ color: 'red' }}>注意：必须提前一个月退租</p>
                    </div>
                    <Form
                        name="showFlagBox"
                        layout="horizontal"
                        scrollToFirstError={true}
                        ref={'showFlagRef'}
                        // preserve={true}
                        labelCol={{ span: 9 }}
                        labelWrap={true}
                        colon={false}
                        className="showFlagBox-form"
                        onFinish={(e) => { tapOnce(this.onFinish, e, 500) }}
                        onFinishFailed={(e) => { tapOnce(this.onFinishFailed, e, 500) }}>
                        <div>
                            <Card title={<div id="application" style={{ borderLeft: '3px solid #1890FF', padding: '0 0 0 5px', fontWeight: 'bold' }}>退租申请</div>} bordered={false}>
                                <Row gutter={[48, 8]}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='evictionType' label='退租类型：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择" onChange={(value) => this.getApplyEvictionDateList(value)}>
                                                <Option value='中期退租'>中期退租</Option>
                                                <Option value='到期退租'>到期退租</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='applyEvictionDate' label='计划退租日：'
                                            rules={[{ required: true, message: '', }]}>
                                            {/* <DatePicker style={{ width: '100%' }} /> */}
                                            <Select placeholder="请选择">
                                                {dateList.map((item, index) => (
                                                    <Option value={item} key={index}>{item}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='bankType' label='退款银行类型：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择">
                                                <Option value='工商银行'>工商银行</Option>
                                                <Option value='农业银行'>农业银行</Option>
                                                <Option value='中国银行'>中国银行</Option>
                                                <Option value='建设银行'>建设银行</Option>
                                                <Option value='交通银行'>交通银行</Option>
                                                <Option value='招商银行'>招商银行</Option>
                                                <Option value='中信实业银行'>中信实业银行</Option>
                                                <Option value='上海浦东发展银行'>上海浦东发展银行</Option>
                                                <Option value='民生银行'>民生银行</Option>
                                                <Option value='光大银行'>光大银行</Option>
                                                <Option value='广东发展银行'>广东发展银行</Option>
                                                <Option value='兴业银行'>兴业银行</Option>
                                                <Option value='华夏银行'>华夏银行</Option>
                                                <Option value='上海银行'>上海银行</Option>
                                                <Option value='北京银行'>北京银行</Option>
                                                <Option value='深圳发展银行'>深圳发展银行</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='bank' label='开户行：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='accountName' label='账户姓名：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='bankAccount' label='账号/卡号：'
                                            rules={[{ required: true, message: '', pattern: /^\d+$/ }]}>
                                            <Input style={{ width: '100%' }} maxLength={30} />
                                            {/* <InputNumber style={{ width: '100%' }} maxLength={30} /> */}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item name='evictionReason' label='退租理由：'
                                            rules={[{ required: false, message: '', }]} className='FormItemName'>
                                            <Input.TextArea maxLength={500} showCount={true} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item name='FormItemName' label={
                                            <p>
                                                <span style={{ color: '#ff4d4f', marginRight: '4px' }}>*</span>
                                                <span style={{ display: 'flex', flexDirection: 'column' }}>附件、图片：
                                                    <span style={{ fontSize: '12px', color: '#AAAAAA85' }}>银行卡（有卡号的一面）</span>
                                                </span>
                                            </p>
                                        }
                                            rules={[{ required: false, message: '', }]} className='FormItemName'>
                                            <UploadsDocx setCommonImages={this.setCommonImages} type='申退照片' serrArr={picture ? picture : ''} />
                                            <p style={{ color: '#AAAAAA85' }}>图片大小单张不超过50MB</p>
                                            {contractAttribute == '单位' ? <p>
                                                <a onClick={this.getTemplate} target='_blank' download='过渡居住申请书.docx'>空白退租申请表.docx <CloudDownloadOutlined style={{ fontSize: '16px', marginTop: '3px' }} /></a>
                                                <span style={{ color: '#AAAAAA85', marginLeft: '1em' }}>请下载该空白表填写后提交</span>
                                            </p> : null}
                                            <UploadsDocx setCommonFile={this.setCommonFile} type='申退文件' serrArr={file ? file : ''} />
                                            <p style={{ color: '#AAAAAA85' }}>支持扩展名：.doc .docx .xls .xlsx .pdf</p>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                        <Checkbox style={{ marginTop: '12px' }} onChange={(e) => {
                            if (!showCheckFlag) {
                                this.setState({ secondsToChecked: e.target.checked })
                            }
                        }} checked={this.state.secondsToChecked}>
                            {
                                window.innerWidth > 500 ? <div>
                                    <p style={{ fontSize: '15px', fontWeight: '600' }}>勾选即代表同意：房屋腾退标准：</p>
                                    <p>1.室内装修和所有固定装置及设备的状况完好；</p>
                                    <p>2.拆除加建的固定装置及设备设施，墙面、地面恢复原状；</p>
                                    <p>3.清理所有杂物及垃圾，并恢复室内环境卫生；</p>
                                    <p>4.结清租赁期内的各类公用事业费及其他应由承租人承担的相关服务费用等；</p>
                                    <p>5.房屋钥匙、遥控器、信报箱钥匙、门禁卡等请按入住移交数量归还；</p>
                                    <p>6.如需退还费用的，个人承租的须提供承租人本人银行卡复印件，单位承租的须提供银行账户信息且加盖单位印章。</p>
                                </div> :
                                    <div>
                                        <p style={{ fontSize: '15px', fontWeight: '600' }}>勾选即代表同意：房屋腾退标准：<a onClick={(event) => {
                                            this.setState({ showInFlag: true, showCheckFlag: true });
                                        }}>点击查看</a></p>
                                    </div>
                            }
                        </Checkbox>
                        <Row>
                            <Col span={24} style={{ textAlign: 'center', marginTop: '2em' }}>
                                {contractAttribute == '单位' ? <Button type="primary" htmlType="submit" disabled={!this.state.secondsToChecked} onClick={() => { tapOnce(this.temporaryStorage) }} style={{ marginRight: '10px' }}>
                                    暂存
                                </Button> : null}
                                <Button type="primary" htmlType="submit" disabled={!this.state.secondsToChecked} >
                                    确定
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal visible={showInFlag} closable={false} maskClosable={false}
                    footer={<Button type="primary" onClick={() => { this.setState({ showInFlag: false, showCheckFlag: false }) }} style={{ display: 'flex', margin: '0 auto' }}>
                        确 认
                    </Button>}>
                    <p>1.室内装修和所有固定装置及设备的状况完好；</p>
                    <p>2.拆除加建的固定装置及设备设施，墙面、地面恢复原状；</p>
                    <p>3.清理所有杂物及垃圾，并恢复室内环境卫生；</p>
                    <p>4.结清租赁期内的各类公用事业费及其他应由承租人承担的相关服务费用等；</p>
                    <p>5.房屋钥匙、遥控器、信报箱钥匙、门禁卡等请按入住移交数量归还；</p>
                    <p>6.如需退还费用的，个人承租的须提供承租人本人银行卡复印件，单位承租的须提供银行账户信息且加盖单位印章。</p>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(modalBox))